
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Form1"
})
export default class extends Vue {
  mounted() {
    this.GetTotalCount();
  }
  private totalcount = "0";
  private GetTotalCount() {
    this.totalcount = obj_PackagePrint.getTotalPrintCount();
  }
}
